import { number, object, string } from 'yup'

const REQUIRED_FIELD = 'validations.requiredField'
const INVALID_EMAIL = 'validations.invalidEmail'

export const optional = string()
export const required = string().trim().notOneOf([''], REQUIRED_FIELD).required(REQUIRED_FIELD)
export const requiredNumber = number().required(REQUIRED_FIELD)
export const requiredEmail = string().email(INVALID_EMAIL).required(REQUIRED_FIELD)
export const createValidationSchema = object

export const rules = {
  optional,
  required,
  requiredNumber,
  requiredEmail,
}
